import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { DEFAULT_USER_DATA, UserDataContext } from './userDataContext';
import { API } from '../arteia-js/services';

class UserDataProvider extends Component {
    state = {
        userData: null,
        isFetching: false,
    };

    componentDidMount() {
        const { location: { search }, history } = this.props;
        const parsed = queryString.parse(search);
        const userId = parsed.uuid;// || '8f4d5dfa-09da-47b4-a0e5-cbe1a507877c';

        if (!userId) {
            history.replace('/login');
        }

        this.setState({
            isFetching: true,
        });

        API.get(`/eeckman/${userId}`)
            .then(res => {
                this.setState({
                    userData: res,
                    isFetching: false,
                });
            })
            .catch(() => {
                this.setState({
                    isFetching: false,
                    userData: DEFAULT_USER_DATA,
                });
            });
    }

    render() {
        const { children } = this.props;
        const { userData } = this.state;

        return (
            <UserDataContext.Provider value={userData}>
                {userData && children}
            </UserDataContext.Provider>
        );
    }
}

UserDataProvider.propTypes = {};
UserDataProvider.defaultProps = {};

export default withRouter(UserDataProvider);



// WEBPACK FOOTER //
// ./src/EeckmanClientInfo/UserDataProvider.js